const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteEscola = async ( id : number , page : string, idUsuLog : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8071/escoles/${idUsuLog}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({id})
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};